import React from "react";
import { ISubLinkDto } from "../../contract";
import { ArticleTile } from "../Articles";

interface PopularArticlesProps {
  popularArticles?: ISubLinkDto[];
}

export const PopularArticles: React.FC<PopularArticlesProps> = ({
  popularArticles,
}) => {
  return (
    <>
      {popularArticles?.map((article, index) => (
        <ArticleTile
          key={`popular-article-key-${index}`}
          article={article}
          data-id={`popular-article-${index}`}
          index={index}
          showDivider={index < popularArticles.length - 1}
        />
      ))}
    </>
  );
};
